import React, { useEffect, useState } from 'react';
import * as Common from "./Common";
import { useNavigate } from 'react-router-dom';
import { Container, Form, Row, Col } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import * as Picklist from "./Picklist"

const CurrencySelector = ({ onDataFromChild2 }) => {

    const sid = sessionStorage.getItem("sessionId");
    const navigate = useNavigate();
    const [userRight, setUserRight] = useState([]);
    const [data, setData] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [radioType, setRadioType] = useState('A');
    const [currency, setCurrency] = useState(null);
    const [currencyCode, setCurrencyCode] = useState(0);

    useEffect(() => {
        Common.callApi(Common.apiRight, [sid, 'all', 'REPORTS'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });

        Common.callApi(Common.apiCheck, [sid, 'currency'], (result) => {
            let resp = JSON.parse(result);
            setData(resp);
        });

        onDataFromChild2(currencyCode, selectedItems.toString(), radioType);
    }, [selectedItems]);


    const handleRadioChange = (value) => {
        setRadioType(value);
        setCurrency(null);
        setCurrencyCode(0);
        setSelectedItems([]);
        onDataFromChild2(currencyCode, selectedItems, value);
    }

    const handleChangeCurrency = (value) => {
        setCurrency(value);
        var cur = value.id.split('^');
        setCurrencyCode(cur[1]);

        onDataFromChild2(cur[1], selectedItems, radioType);
    }


    const checkBoxHandler = (e) => {
        let checked = e.target.checked;
        let value = e.target.value;
        setSelectedItems((prevSelectedItems) => {
            if (checked) {
                return [...prevSelectedItems, value];
            } else {
                return prevSelectedItems.filter((item) => item !== value);
            }
        });
    }


    const myStyle = {
        height: "250px",
        border: "1px solid black",
        // width: "30%",
    };


    const myStyle2 = {
        height: "195px",
        overflow: "hidden scroll",
        padding: "5px 10px",
    }


    return (
        <>
            <Row>
                <Col style={{ display: "flex" }}>
                    <Form.Check checked={radioType === "A"} onChange={() => handleRadioChange("A")} type='radio' label="All" />
                    <Form.Check checked={radioType === "O"} onChange={() => handleRadioChange("O")} type='radio' label="One" />
                    <Form.Check checked={radioType === "S"} onChange={() => handleRadioChange("S")} type='radio' label="Selective" />
                </Col>
            </Row>
            <Row>
                <Col className='col-md-6 col-6'>
                    {
                        radioType === 'A' ?
                            <>

                            </>
                            :
                            radioType === 'O' ?
                                <>
                                    <Form.Group>
                                        <Form.Label>Currency<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={currency}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, 'CN')}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleChangeCurrency}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </>
                                :
                                <>
                                    <div style={myStyle}>
                                        <div style={{ backgroundColor: "lightblue", color: "white", padding: "0 0 0 10px" }}>
                                            <Row>
                                                <Col><h3>Locations List</h3></Col>
                                            </Row>
                                        </div>
                                        <div style={myStyle2}>
                                            {
                                                data.map((item, index) => (
                                                    <div key={index} className="mb-3">
                                                        <Form.Check
                                                            label={item.isd}
                                                            type="checkbox"
                                                            value={item.isd_code}
                                                            onChange={(e) => checkBoxHandler(e)}
                                                        />
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </>
                    }
                </Col>
            </Row>
        </>
    )
}

export default CurrencySelector;
